import React from "react";
import { colones } from "@/lib/api";

export function AusenteCell({ dias, testId }) {
  if (!dias) return <span className="text-secondary-c" data-testid={testId}>—</span>;
  return <span className="font-medium text-xs text-error" data-testid={testId}>{dias} {dias === 1 ? "día" : "días"}</span>;
}

// Celda compacta para mostrar un concepto en la planilla (Día Libre, Incapacidad, Vacaciones, Licencia)
export default function ConceptoCell({ dias, monto, sub }) {
  if (!dias && !monto) return <span className="text-secondary-c">—</span>;
  return (
    <div>
      <div className="font-medium text-xs">{dias} {dias === 1 ? "día" : "días"}</div>
      <div className="text-[11px] text-success font-medium">{colones(monto)}</div>
      {sub && <div className="text-[10px] text-secondary-c">{sub}</div>}
    </div>
  );
}
